import {
  LLD_WAITING_USERS_PENDING,
  LLD_WAITING_USERS_FAILED,
  LLD_WAITING_USERS_DOWNLOADED,
  LLD_WAITING_USERS_REMOVED,
  LLD_WAITING_USERS_SENDING,
} from './types';

export const INITIAL_STATE = {
  error: null,
  content: null,
  pending: false,
  sending: false,
};

export default function (state = INITIAL_STATE, action) {
  let lldWaitingUsers = [];
  let lldWaitingUserIndex = -1;
  switch (action.type) {
    case LLD_WAITING_USERS_PENDING:
      return {
        ...state,
        pending: true,
      };
    case LLD_WAITING_USERS_FAILED:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    case LLD_WAITING_USERS_DOWNLOADED:
      return {
        ...state,
        pending: false,
        content: action.payload,
      };
    case LLD_WAITING_USERS_REMOVED:
      if (state.content) {
        lldWaitingUsers = state.content.slice();
        lldWaitingUserIndex = lldWaitingUsers.findIndex(
          (lldWaitingUser) => lldWaitingUser.id === action.payload,
        );
        if (lldWaitingUserIndex !== -1) {
          lldWaitingUsers.splice(lldWaitingUserIndex, 1);
        }
      }
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        content: lldWaitingUsers,
      };
    case LLD_WAITING_USERS_SENDING:
      return {
        ...state,
        sending: true,
      };
    default:
      break;
  }
  return state;
}


// WEBPACK FOOTER //
// ./src/store/lldWaitingUsers/reducers.js